export default __webpack_public_path__ + "static/TungstenCondensed-Bold-dab212916d76f6df891ce078817fa336.woff2";